import Api from './Api';

/**
 * Handle transaltions
 */
class Translations {
    /**
     * Contains all translated labels, indexed by their key
     */
    translations = {};

    /**
     * Loads the translations for the given country/language
     * 
     * @param {string} country
     * @param {string} language
     */
    load = (country, language) => {
        return new Promise((resolve, reject) => {
            Api
                .getTranslation(country, language)
                .then(translations => {
                    this.translations = translations;

                    resolve();
                });
        });
    }

    /**
     * Returns the translated label at the given key or the key itself if
     * the label does not exists.
     * 
     * @param {string} key
     * 
     * @return {string} The translated label or the key if the label does not exists
     */
    translate = key => this.translations[key] || key;
};

const translations = new Translations();

/**
 * Shortcut to translate method of Translation.
 * 
 * Returns the translated label at the given key or the key itself if
 * the label does not exists.
 * 
 * @param {string} key
 * 
 * @return {string} The translated label or the key if the label does not exists
 */
export const t = key => translations.translate(key);

export default translations;


// WEBPACK FOOTER //
// ./src/Translations.js